import { forwardRef } from 'react';
import { UnstyledButton, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import clsx from 'clsx';

import { FONT_WEIGHT_SEMIBOLD } from '@/constants/ui';
import type { WorkspaceSelectorTargetProps } from './WorkspaceSelector.types';
import { WorkspaceAvatar } from './WorkspaceAvatar';
import styles from './WorkspaceSelector.module.css';

export const WorkspaceSelectorTarget = forwardRef<
  HTMLButtonElement,
  WorkspaceSelectorTargetProps
>(function WorkspaceSelectorTarget(
  { workspace, isOpen, fullWidth, className, ...others },
  ref
) {
  const name = workspace?.name || 'Workspace';

  return (
    <UnstyledButton
      ref={ref}
      className={clsx(
        styles.trigger,
        fullWidth && styles.triggerFullWidth,
        className
      )}
      aria-label={`Current workspace: ${name}`}
      {...others}
    >
      <WorkspaceAvatar name={name} size="sm" shape="rounded" />
      <div className={styles.triggerInfo}>
        <Text
          size="sm"
          fw={FONT_WEIGHT_SEMIBOLD}
          lineClamp={1}
          className={styles.triggerName}
        >
          {name}
        </Text>
        {workspace?.description && (
          <Text
            size="xs"
            c="dimmed"
            lineClamp={1}
            className={styles.triggerDescription}
          >
            {workspace.description}
          </Text>
        )}
      </div>
      <IconChevronDown
        size={16}
        className={clsx(
          styles.triggerChevron,
          isOpen && styles.triggerChevronOpen
        )}
      />
    </UnstyledButton>
  );
});
